import { Settings, X, Minimize2, Maximize2, TrendingUp, TrendingDown } from 'lucide-react'

export default function VwapBadge({
  result,
  onOpenSettings,
  onClose,
  onMinimize,
  minimized = false,
  version = '1.1',
  onHeaderMouseDown,
}) {
  const lastValue = result?.lastValue ?? null
  const lastPrice = result?.lastPrice ?? null

  let above = null
  if (lastValue != null && lastPrice != null) {
    above = lastPrice >= lastValue
  }

  const status = above ? 'Sobre' : above === false ? 'Bajo' : ''
  const statusColor = above ? '#35A07A' : '#B4574B'

  return (
    <div
      className="absolute top-2 left-2 z-10 flex flex-col gap-1 rounded-lg backdrop-blur-sm shadow-lg overflow-hidden min-w-[170px]"
      style={{ background: 'var(--paper, #FDFDFA)', border: '1px solid var(--hair, rgba(176,141,87,0.35))' }}
    >
      <div
        className="flex items-center gap-1.5 px-2.5 pt-2 pb-1 cursor-grab active:cursor-grabbing"
        onMouseDown={onHeaderMouseDown}
      >
        <span
          className="text-[11px] font-semibold tracking-tight"
          style={{ fontFamily: "'Playfair Display', Georgia, serif", color: 'var(--green-deep, #0B3D2E)' }}
        >
          VWAP <span className="opacity-60 font-normal">[{version}]</span>
          {minimized && status && (
            <span className="ml-1.5 text-[10px]" style={{ color: statusColor }}>· {status}</span>
          )}
        </span>
        <button onClick={onOpenSettings} title="Configuración" className="ml-auto p-0.5 transition-colors rounded hover:bg-black/5" style={{ color: 'var(--ink, #15211B)' }}>
          <Settings size={12} />
        </button>
        {minimized ? (
          <button onClick={onMinimize} title="Expandir" className="p-0.5 transition-colors rounded hover:bg-black/5" style={{ color: 'var(--ink, #15211B)' }}>
            <Maximize2 size={12} />
          </button>
        ) : (
          <button onClick={onMinimize} title="Minimizar" className="p-0.5 transition-colors rounded hover:bg-black/5" style={{ color: 'var(--ink, #15211B)' }}>
            <Minimize2 size={12} />
          </button>
        )}
        <button onClick={onClose} title="Ocultar dashboard" className="p-0.5 transition-colors rounded hover:bg-black/5" style={{ color: 'var(--ink, #15211B)' }}>
          <X size={12} />
        </button>
      </div>

      {!minimized && lastValue != null && (
        <div className="px-2.5 pb-2 space-y-1">
          <div className="flex items-center justify-between">
            <span className="text-[10px]" style={{ color: 'var(--ink-soft, #4A5A52)' }}>VWAP</span>
            <span className="text-[11px] font-semibold tabular-nums" style={{ color: 'var(--ink, #15211B)' }}>
              {lastValue.toFixed(2)}
            </span>
          </div>
          {above != null && (
            <div className="flex items-center justify-between">
              <span className="text-[10px]" style={{ color: 'var(--ink-soft, #4A5A52)' }}>Precio</span>
              <span
                className="text-[10px] font-medium flex items-center gap-0.5"
                style={{ color: above ? '#35A07A' : '#B4574B' }}
              >
                {above ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                {above ? 'Sobre' : 'Bajo'} VWAP
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
